

































import Vue, { PropType } from "vue";
import * as dateHandling from "@/commons/utils/dateHandling";
import { OverallTrends } from "@/features/home/types";

export default Vue.extend({
  props: {
    overallTrends: {
      type: Object as PropType<OverallTrends>,
      required: true,
    },
    tab: { type: Number, required: true },
    loading: { type: Boolean, required: true },
  },
  data() {
    return {
      dateStrings: "" as string,
    };
  },
  watch: {
    overallTrends: function setDisplayPeriod() {
      let dateList = this.overallTrends.labels;
      this.dateStrings = `${dateList[0]}〜${dateList[dateList.length - 1]}`;
    },
  },
  methods: {
    getScrapingUpdatedDateTime(): string {
      return dateHandling.getYesterdayMidnight();
    },
    isFailedToGetOverAllTrends(): boolean {
      return this.overallTrends.labels.length === 0;
    },
  },
});
